import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { ApiPropertyValuationprojectCycleConstants } from "../../../../../../shared/constants/api-constants/api-property-valuation-project-cycle.constants";
import { ApiPropertyValuationprojectCycleFactorAdjustmentsConstants } from "../../../../../../shared/constants/api-constants/api-property-valuation-project-cycle-factor-adjustments.constants";
import { ApiPropertyValuationprojectCycleStructureTypesConstants } from "../../../../../../shared/constants/api-constants/api-property-valuation-project-cycle-structure-types.constants";
import { ApiPropertyValuationprojectCycleValueAdjustmentsConstants } from "../../../../../../shared/constants/api-constants/api-property-valuation-project-cycle-value-adjustments.constants";
import { ApiPropertyValuationprojectCycleDepreciationFactorsConstants } from "../../../../../../shared/constants/api-constants/api-property-valuation-project-cycle-depreciation-factors.constants";
import { ApiPropertyValuationprojectCycleAgriculturalActivityConstants } from "../../../../../../shared/constants/api-constants/api-property-valuation-project-cycle-agricultural-activity.constants";
import { ApiPropertyValuationprojectCycleSurveysConstants } from "../../../../../../shared/constants/api-constants/api-property-valuation-project-cycle-surveys.constants";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiLookupConstants } from "../../../../../../shared/constants/api-constants/api-lookup.constants";
import { ApiAvailableSurveyConstants } from "../../../../../../shared/constants/api-constants/api-available-survey.constants";
let AttributesAndParametersService = class AttributesAndParametersService {
    http;
    selectedprojectCycleId = null;
    existingSurveys = false;
    constructor(http) {
        this.http = http;
    }
    getprojectCycle(params) {
        return this.http
            .get(ApiPropertyValuationprojectCycleConstants.URL, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    getprojectCycleFactorAdjustments(params) {
        return this.http
            .get(ApiPropertyValuationprojectCycleFactorAdjustmentsConstants.URL, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    getprojectCycleStructureTypes(params) {
        return this.http
            .get(ApiPropertyValuationprojectCycleStructureTypesConstants.URL, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    getprojectCycleValueAdjustments(params) {
        return this.http
            .get(ApiPropertyValuationprojectCycleValueAdjustmentsConstants.URL, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    getprojectCycleDepreciationFactors(params) {
        return this.http
            .get(ApiPropertyValuationprojectCycleDepreciationFactorsConstants.URL, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    getprojectCycleAgriculturalActivities(params) {
        return this.http
            .get(ApiPropertyValuationprojectCycleAgriculturalActivityConstants.URL, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    getprojectCycleSurveys(params) {
        return this.http
            .get(ApiPropertyValuationprojectCycleSurveysConstants.URL, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    createRunFactorAdjustments(params) {
        return this.http.post(`${ApiPropertyValuationprojectCycleFactorAdjustmentsConstants.URL}`, params);
    }
    createRunStructureTypes(params) {
        return this.http.post(`${ApiPropertyValuationprojectCycleStructureTypesConstants.URL}`, params);
    }
    createRunValueAdjustments(params) {
        return this.http.post(`${ApiPropertyValuationprojectCycleValueAdjustmentsConstants.URL}`, params);
    }
    createRunDepreciationFactors(params) {
        return this.http.post(`${ApiPropertyValuationprojectCycleDepreciationFactorsConstants.URL}`, params);
    }
    createRunAgriculturalActivities(params) {
        return this.http.post(`${ApiPropertyValuationprojectCycleAgriculturalActivityConstants.URL}`, params);
    }
    updateRunFactorAdjustments(projectCycleID, params) {
        return this.http.patch(`${ApiPropertyValuationprojectCycleFactorAdjustmentsConstants.URL}/${projectCycleID}`, params);
    }
    updateRunValueAdjustments(projectCycleID, params) {
        return this.http.patch(`${ApiPropertyValuationprojectCycleValueAdjustmentsConstants.URL}/${projectCycleID}`, params);
    }
    updateRunStructureTypes(projectCycleID, params) {
        return this.http.patch(`${ApiPropertyValuationprojectCycleStructureTypesConstants.URL}/${projectCycleID}`, params);
    }
    updateRunDepreciationFactors(projectCycleID, params) {
        return this.http.patch(`${ApiPropertyValuationprojectCycleDepreciationFactorsConstants.URL}/${projectCycleID}`, params);
    }
    updateRunAgriculturalActivities(projectCycleID, params) {
        return this.http.patch(`${ApiPropertyValuationprojectCycleAgriculturalActivityConstants.URL}/${projectCycleID}`, params);
    }
    deleteFactorAdjustments(projectCycleID, ids) {
        return this.http.post(`${ApiPropertyValuationprojectCycleFactorAdjustmentsConstants.URL}/${ApiPropertyValuationprojectCycleFactorAdjustmentsConstants.FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_FACTOR_ADJUSTMENTS}`, { ids });
    }
    deleteValueAdjustments(projectCycleID, ids) {
        return this.http.post(`${ApiPropertyValuationprojectCycleValueAdjustmentsConstants.URL}/${ApiPropertyValuationprojectCycleValueAdjustmentsConstants.FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_VALUE_ADJUSTMENTS}`, { ids });
    }
    deleteStructureTypes(projectCycleID, ids) {
        return this.http.post(`${ApiPropertyValuationprojectCycleStructureTypesConstants.URL}/${ApiPropertyValuationprojectCycleStructureTypesConstants.FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_STRUCTURE_TYPES}`, { ids });
    }
    deleteDepreciationFactors(projectCycleID, ids) {
        return this.http.post(`${ApiPropertyValuationprojectCycleDepreciationFactorsConstants.URL}/${ApiPropertyValuationprojectCycleDepreciationFactorsConstants.FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_DEPRECIATION_FACTORS}`, { ids });
    }
    deleteAgriculturalActivities(projectCycleID, ids) {
        return this.http.post(`${ApiPropertyValuationprojectCycleAgriculturalActivityConstants.URL}/${ApiPropertyValuationprojectCycleAgriculturalActivityConstants.FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_AGRICULTURE_ACTIVITIES}`, { ids });
    }
    getValuationMethods(params) {
        return this.http.get(ApiLookupConstants.URL, { params }).pipe(map((lookups) => {
            return lookups;
        }));
    }
    getExistingSurveys(projectCycleID, params) {
        return this.http
            .get(`${ApiPropertyValuationprojectCycleConstants.URL}/${projectCycleID}/${ApiPropertyValuationprojectCycleConstants.FUNCTION_CHECK_FOR_EXISTING_SURVEYS}`, { params })
            .pipe(map((surveys) => {
            return surveys;
        }));
    }
    getAvailableSurveys123(params) {
        return this.http.get(ApiAvailableSurveyConstants.URL, {
            params,
        });
    }
    createValuationRunSurvey(newRunSurvey) {
        return this.http.post(ApiPropertyValuationprojectCycleSurveysConstants.URL, newRunSurvey);
    }
    updateValuationRunSurvey(projectCycleID, params) {
        return this.http.patch(`${ApiPropertyValuationprojectCycleSurveysConstants.URL}/${projectCycleID}`, params);
    }
    deleteValuationRunSurvey(projectCycleID, ids) {
        return this.http.post(`${ApiPropertyValuationprojectCycleSurveysConstants.URL}/${ApiPropertyValuationprojectCycleSurveysConstants.FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_SURVEYS}`, { ids });
    }
    postprojectCycleParameter(projectCycleID, params) {
        return this.http.post(`${ApiPropertyValuationprojectCycleConstants.URL}/${projectCycleID}/${ApiPropertyValuationprojectCycleConstants.FUNCTION_SET_PARAMETER}`, params);
    }
    uploadRunAgriculturalActivities(projectCycleID, params) {
        return this.http
            .post(`${ApiPropertyValuationprojectCycleAgriculturalActivityConstants.URL}/${projectCycleID}/${ApiPropertyValuationprojectCycleAgriculturalActivityConstants.FUNCTION_UPLOAD_GENERAL_VALUATION_RUN_AGRICULTURE_ACTIVITIES}`, params)
            .pipe(map((response) => {
            return response.value;
        }));
    }
    uploadRunDepreciationFactors(projectCycleID, params) {
        return this.http
            .post(`${ApiPropertyValuationprojectCycleDepreciationFactorsConstants.URL}/${projectCycleID}/${ApiPropertyValuationprojectCycleDepreciationFactorsConstants.FUNCTION_UPLOAD_GENERAL_VALUATION_RUN_DEPRECIATION_FACTORS}`, params)
            .pipe(map((response) => {
            return response.value;
        }));
    }
    uploadRunFactorAdjustments(projectCycleID, params) {
        return this.http
            .post(`${ApiPropertyValuationprojectCycleFactorAdjustmentsConstants.URL}/${projectCycleID}/${ApiPropertyValuationprojectCycleFactorAdjustmentsConstants.FUNCTION_UPLOAD_GENERAL_VALUATION_RUN_FACTOR_ADJUSTMENTS}`, params)
            .pipe(map((response) => {
            return response.value;
        }));
    }
    uploadRunStructureTypes(projectCycleID, params) {
        return this.http
            .post(`${ApiPropertyValuationprojectCycleStructureTypesConstants.URL}/${projectCycleID}/${ApiPropertyValuationprojectCycleStructureTypesConstants.FUNCTION_UPLOAD_GENERAL_VALUATION_RUN_STRUCTURE_TYPES}`, params)
            .pipe(map((response) => {
            return response.value;
        }));
    }
    uploadRunValueAdjustments(projectCycleID, params) {
        return this.http
            .post(`${ApiPropertyValuationprojectCycleValueAdjustmentsConstants.URL}/${projectCycleID}/${ApiPropertyValuationprojectCycleValueAdjustmentsConstants.FUNCTION_UPLOAD_GENERAL_VALUATION_RUN_VALUE_ADJUSTMENTS}`, params)
            .pipe(map((response) => {
            return response.value;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
AttributesAndParametersService = __decorate([
    Injectable({
        providedIn: "root",
    })
], AttributesAndParametersService);
export { AttributesAndParametersService };
